export const ACTION_TYPE = {
  ORDERS_LIST: 'ORDERS_LIST',
  SUBSCRIPTIONS_LIST: 'SUBSCRIPTIONS_LIST',
  TARIFFS_LIST: 'TARIFFS_LIST',
};
